import { render, staticRenderFns } from "./lookforPwd.vue?vue&type=template&id=44f338da&scoped=true&"
import script from "./lookforPwd.vue?vue&type=script&lang=js&"
export * from "./lookforPwd.vue?vue&type=script&lang=js&"
import style0 from "./lookforPwd.vue?vue&type=style&index=0&id=44f338da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f338da",
  null
  
)

export default component.exports